@if (complementaryProductViewModel$ | async; as vm) {
  <div class="tunnel-page-container">
    @if (showMarketingCard) {
      <div class="card-marketing-container">
        <ng-casto-card-marketing [imageSrc]="placeholderImageSrc">
          <ng-template #bodyTemplate>
          </ng-template>
        </ng-casto-card-marketing>
      </div>
    }
    <div class="body-container">
      @if (isFilterMenuOpen) {
        <ng-casto-complementary-product-filter
          [@slideIn]
          (@slideIn.done)="onFilterAnimationDone($event)"
          [products]="vm.displayedProducts"
          [(isOpen)]="isFilterMenuOpen"
          [selectedFilters$]="selectedFilters$"
          [class.filter-open]="isFilterMenuOpen"
        ></ng-casto-complementary-product-filter>
      }
      <div class="complementary-product-container" [class.filter-open]="!showMarketingCard">
        <div class="casto-card" [ngClass]="{
    'filter-open': isFilterMenuOpen
    }">
          <div class="header">
            <span class="casto-title large" [innerHTML]="'complementary-products.title'|translate"></span>
            <div class="prices">
              <div class="total">
              <span class="casto-title"
                    [innerHTML]="'complementary-products.prices.subtotal-products'|translate"></span>
                @if (vm.updateProductLoading || vm.pricingLoading) {
                  <p-skeleton width="5rem" height="1.5rem"></p-skeleton>
                } @else {
                  @if (vm.displayDiscount) {
                    <span
                      class="casto-title casto-discount"
                      [innerHTML]="
                            vm.complementaryProductTotal.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                          "></span>
                  }
                  <span
                    class="casto-title blue"
                    [innerHTML]="
            vm.complementaryProductTotal.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
          "></span>
                }
              </div>
            </div>
          </div>
          <div class="content">
            <div class="filter">
              <div class="search-bar">
                <ng-casto-button [class]="isFilterMenuOpen? 'secondary' :'primary'"
                                 (click)="isFilterMenuOpen ? isFilterMenuOpen = false : openFilter()"
                                 [faIcon]="isFilterMenuOpen ? faArrowRight : faList"></ng-casto-button>

                <input
                  #filterInput
                  type="text"
                  pInputText
                  [placeholder]="'complementary-products.search.placeholder' | translate"
                  [value]="vm.searchInput"
                  (input)="updateSearchInput($any($event.target).value)" />
                <ng-casto-button (click)="requestComplementaryProduct()"
                                 [label]="'complementary-products.request' | translate"></ng-casto-button>
              </div>
            </div>
            <div class="chips-wrapper">
              <ng-casto-complementary-product-chips
                [selectedFilters$]="selectedFilters$"></ng-casto-complementary-product-chips>
            </div>
            @if (vm.hasRemovedProducts) {
              <div class="removed-products-warning" [innerHTML]="'complementary-products.removed-products-warning'|translate"></div>
            }
            <div class="tab-menu">
              <p-tabMenu [model]="tabMenuItems" [(activeItem)]="activeItem"
                         styleClass="complementary-product-tabs" />
            </div>
            @switch (activeItem.id) {
              @case (ComplementaryProductTab.Favorite) {
                <div class="complementary-product-list-wrapper">
                  <ng-casto-complementary-product-list [fetchProductsLoading]="vm.fetchProductsLoading"
                                                       [filteredProducts$]="favoriteProducts$"
                                                       (onProductQuantityChange)="setProductQuantity($event.product, $event.quantity)"></ng-casto-complementary-product-list>
                </div>
              }
              @case (ComplementaryProductTab.AllProducts) {
                <div class="complementary-product-list-wrapper">
                  <ng-casto-complementary-product-list [fetchProductsLoading]="vm.fetchProductsLoading"
                                                       [filteredProducts$]="filteredProducts$"
                                                       (onProductQuantityChange)="setProductQuantity($event.product, $event.quantity)"></ng-casto-complementary-product-list>
                </div>
              }
              @default {

              }
            }
          </div>
        </div>
      </div>
    </div>
    <div class="action-bar-container">
      <ng-casto-action-bar></ng-casto-action-bar>
    </div>
  </div>
} @else {
  <div class="tunnel-page-container">
    <p-skeleton width="100%" height="6rem"></p-skeleton>
  </div>
}
